package com.eladfinish.bible.contest.ui.icons

import androidx.compose.material.icons.materialIcon
import androidx.compose.material.icons.materialPath
import androidx.compose.ui.graphics.vector.ImageVector

// Vendored from androidx.compose.material:material-icons-extended (Apache License 2.0), which the
// app depended on for these 4 icons alone — pulling in that whole ~2000-icon, ~38MB artifact for
// 4 of them was the single biggest avoidable chunk of the desktop build's download size. Every
// other icon this app uses (ArrowBack, ArrowDropDown, Clear, ExitToApp, Share, ...) already ships
// in the much smaller material-icons-core, which this app still depends on.
object AppIcons {

    val ContentCopy: ImageVector
        get() {
            if (_contentCopy != null) return _contentCopy!!
            _contentCopy = materialIcon(name = "Filled.ContentCopy") {
                materialPath {
                    moveTo(16.0f, 1.0f)
                    lineTo(4.0f, 1.0f)
                    curveToRelative(-1.1f, 0.0f, -2.0f, 0.9f, -2.0f, 2.0f)
                    verticalLineToRelative(14.0f)
                    horizontalLineToRelative(2.0f)
                    lineTo(4.0f, 3.0f)
                    horizontalLineToRelative(12.0f)
                    lineTo(16.0f, 1.0f)
                    close()
                    moveTo(19.0f, 5.0f)
                    lineTo(8.0f, 5.0f)
                    curveToRelative(-1.1f, 0.0f, -2.0f, 0.9f, -2.0f, 2.0f)
                    verticalLineToRelative(14.0f)
                    curveToRelative(0.0f, 1.1f, 0.9f, 2.0f, 2.0f, 2.0f)
                    horizontalLineToRelative(11.0f)
                    curveToRelative(1.1f, 0.0f, 2.0f, -0.9f, 2.0f, -2.0f)
                    lineTo(21.0f, 7.0f)
                    curveToRelative(0.0f, -1.1f, -0.9f, -2.0f, -2.0f, -2.0f)
                    close()
                    moveTo(19.0f, 21.0f)
                    lineTo(8.0f, 21.0f)
                    lineTo(8.0f, 7.0f)
                    horizontalLineToRelative(11.0f)
                    verticalLineToRelative(14.0f)
                    close()
                }
            }
            return _contentCopy!!
        }

    val ContentPaste: ImageVector
        get() {
            if (_contentPaste != null) return _contentPaste!!
            _contentPaste = materialIcon(name = "Filled.ContentPaste") {
                materialPath {
                    moveTo(19.0f, 2.0f)
                    horizontalLineToRelative(-4.18f)
                    curveTo(14.4f, 0.84f, 13.3f, 0.0f, 12.0f, 0.0f)
                    curveToRelative(-1.3f, 0.0f, -2.4f, 0.84f, -2.82f, 2.0f)
                    lineTo(5.0f, 2.0f)
                    curveToRelative(-1.1f, 0.0f, -2.0f, 0.9f, -2.0f, 2.0f)
                    verticalLineToRelative(16.0f)
                    curveToRelative(0.0f, 1.1f, 0.9f, 2.0f, 2.0f, 2.0f)
                    horizontalLineToRelative(14.0f)
                    curveToRelative(1.1f, 0.0f, 2.0f, -0.9f, 2.0f, -2.0f)
                    lineTo(21.0f, 4.0f)
                    curveToRelative(0.0f, -1.1f, -0.9f, -2.0f, -2.0f, -2.0f)
                    close()
                    moveTo(12.0f, 2.0f)
                    curveToRelative(0.55f, 0.0f, 1.0f, 0.45f, 1.0f, 1.0f)
                    reflectiveCurveToRelative(-0.45f, 1.0f, -1.0f, 1.0f)
                    reflectiveCurveToRelative(-1.0f, -0.45f, -1.0f, -1.0f)
                    reflectiveCurveToRelative(0.45f, -1.0f, 1.0f, -1.0f)
                    close()
                    moveTo(19.0f, 20.0f)
                    lineTo(5.0f, 20.0f)
                    lineTo(5.0f, 4.0f)
                    horizontalLineToRelative(2.0f)
                    verticalLineToRelative(3.0f)
                    horizontalLineToRelative(10.0f)
                    lineTo(17.0f, 4.0f)
                    horizontalLineToRelative(2.0f)
                    verticalLineToRelative(16.0f)
                    close()
                }
            }
            return _contentPaste!!
        }

    val ImportExport: ImageVector
        get() {
            if (_importExport != null) return _importExport!!
            _importExport = materialIcon(name = "Filled.ImportExport") {
                materialPath {
                    moveTo(9.0f, 3.0f)
                    lineTo(5.0f, 6.99f)
                    horizontalLineToRelative(3.0f)
                    lineTo(8.0f, 14.0f)
                    horizontalLineToRelative(2.0f)
                    lineTo(10.0f, 6.99f)
                    horizontalLineToRelative(3.0f)
                    lineTo(9.0f, 3.0f)
                    close()
                    moveTo(16.0f, 17.01f)
                    lineTo(16.0f, 10.0f)
                    horizontalLineToRelative(-2.0f)
                    verticalLineToRelative(7.01f)
                    horizontalLineToRelative(-3.0f)
                    lineTo(15.0f, 21.0f)
                    lineToRelative(4.0f, -3.99f)
                    horizontalLineToRelative(-3.0f)
                    close()
                }
            }
            return _importExport!!
        }

    val MenuOpen: ImageVector
        get() {
            if (_menuOpen != null) return _menuOpen!!
            _menuOpen = materialIcon(name = "AutoMirrored.Filled.MenuOpen", autoMirror = true) {
                materialPath {
                    moveTo(3.0f, 18.0f)
                    horizontalLineToRelative(13.0f)
                    verticalLineToRelative(-2.0f)
                    lineTo(3.0f, 16.0f)
                    verticalLineToRelative(2.0f)
                    close()
                    moveTo(3.0f, 13.0f)
                    horizontalLineToRelative(10.0f)
                    verticalLineToRelative(-2.0f)
                    lineTo(3.0f, 11.0f)
                    verticalLineToRelative(2.0f)
                    close()
                    moveTo(3.0f, 6.0f)
                    verticalLineToRelative(2.0f)
                    horizontalLineToRelative(13.0f)
                    lineTo(16.0f, 6.0f)
                    lineTo(3.0f, 6.0f)
                    close()
                    moveTo(21.0f, 15.59f)
                    lineTo(17.42f, 12.0f)
                    lineTo(21.0f, 8.41f)
                    lineTo(19.59f, 7.0f)
                    lineToRelative(-5.0f, 5.0f)
                    lineToRelative(5.0f, 5.0f)
                    lineTo(21.0f, 15.59f)
                    close()
                }
            }
            return _menuOpen!!
        }

    private var _contentCopy: ImageVector? = null
    private var _contentPaste: ImageVector? = null
    private var _importExport: ImageVector? = null
    val AdsClick: ImageVector
        get() {
            if (_adsClick != null) return _adsClick!!
            _adsClick = materialIcon(name = "Filled.AdsClick") {
                materialPath {
                    moveTo(11.71f, 17.99f)
                    curveTo(8.53f, 17.84f, 6.0f, 15.22f, 6.0f, 12.0f)
                    curveToRelative(0.0f, -3.31f, 2.69f, -6.0f, 6.0f, -6.0f)
                    curveToRelative(3.22f, 0.0f, 5.84f, 2.53f, 5.99f, 5.71f)
                    lineToRelative(-2.1f, -0.63f)
                    curveTo(15.48f, 9.31f, 13.89f, 8.0f, 12.0f, 8.0f)
                    curveToRelative(-2.21f, 0.0f, -4.0f, 1.79f, -4.0f, 4.0f)
                    curveToRelative(0.0f, 1.89f, 1.31f, 3.48f, 3.08f, 3.89f)
                    lineTo(11.71f, 17.99f)
                    close()
                    moveTo(22.0f, 12.0f)
                    curveToRelative(0.0f, 0.3f, -0.01f, 0.6f, -0.04f, 0.9f)
                    lineToRelative(-1.97f, -0.59f)
                    curveTo(20.0f, 12.21f, 20.0f, 12.1f, 20.0f, 12.0f)
                    curveToRelative(0.0f, -4.42f, -3.58f, -8.0f, -8.0f, -8.0f)
                    reflectiveCurveToRelative(-8.0f, 3.58f, -8.0f, 8.0f)
                    reflectiveCurveToRelative(3.58f, 8.0f, 8.0f, 8.0f)
                    curveToRelative(0.1f, 0.0f, 0.21f, 0.0f, 0.31f, -0.01f)
                    lineToRelative(0.59f, 1.97f)
                    curveTo(12.6f, 21.99f, 12.3f, 22.0f, 12.0f, 22.0f)
                    curveTo(6.48f, 22.0f, 2.0f, 17.52f, 2.0f, 12.0f)
                    curveTo(2.0f, 6.48f, 6.48f, 2.0f, 12.0f, 2.0f)
                    reflectiveCurveTo(22.0f, 6.48f, 22.0f, 12.0f)
                    close()
                    moveTo(18.23f, 16.26f)
                    lineTo(22.0f, 15.0f)
                    lineToRelative(-10.0f, -3.0f)
                    lineToRelative(3.0f, 10.0f)
                    lineToRelative(1.26f, -3.77f)
                    lineToRelative(4.27f, 4.27f)
                    lineToRelative(1.98f, -1.98f)
                    lineTo(18.23f, 16.26f)
                    close()
                }
            }
            return _adsClick!!
        }

    val BugReport: ImageVector
        get() {
            if (_bugReport != null) return _bugReport!!
            _bugReport = materialIcon(name = "Filled.BugReport") {
                materialPath {
                    moveTo(20.0f, 8.0f)
                    horizontalLineToRelative(-2.81f)
                    curveToRelative(-0.45f, -0.78f, -1.07f, -1.45f, -1.82f, -1.96f)
                    lineTo(17.0f, 4.41f)
                    lineTo(15.59f, 3.0f)
                    lineToRelative(-2.17f, 2.17f)
                    curveTo(12.96f, 5.06f, 12.49f, 5.0f, 12.0f, 5.0f)
                    curveToRelative(-0.49f, 0.0f, -0.96f, 0.06f, -1.41f, 0.17f)
                    lineTo(8.41f, 3.0f)
                    lineTo(7.0f, 4.41f)
                    lineToRelative(1.62f, 1.63f)
                    curveTo(7.88f, 6.55f, 7.26f, 7.22f, 6.81f, 8.0f)
                    lineTo(4.0f, 8.0f)
                    verticalLineToRelative(2.0f)
                    horizontalLineToRelative(2.09f)
                    curveToRelative(-0.05f, 0.33f, -0.09f, 0.66f, -0.09f, 1.0f)
                    verticalLineToRelative(1.0f)
                    lineTo(4.0f, 12.0f)
                    verticalLineToRelative(2.0f)
                    horizontalLineToRelative(2.0f)
                    verticalLineToRelative(1.0f)
                    curveToRelative(0.0f, 0.34f, 0.04f, 0.67f, 0.09f, 1.0f)
                    lineTo(4.0f, 16.0f)
                    verticalLineToRelative(2.0f)
                    horizontalLineToRelative(2.81f)
                    curveToRelative(1.04f, 1.79f, 2.97f, 3.0f, 5.19f, 3.0f)
                    reflectiveCurveToRelative(4.15f, -1.21f, 5.19f, -3.0f)
                    lineTo(20.0f, 18.0f)
                    verticalLineToRelative(-2.0f)
                    horizontalLineToRelative(-2.09f)
                    curveToRelative(0.05f, -0.33f, 0.09f, -0.66f, 0.09f, -1.0f)
                    verticalLineToRelative(-1.0f)
                    horizontalLineToRelative(2.0f)
                    verticalLineToRelative(-2.0f)
                    horizontalLineToRelative(-2.0f)
                    verticalLineToRelative(-1.0f)
                    curveToRelative(0.0f, -0.34f, -0.04f, -0.67f, -0.09f, -1.0f)
                    lineTo(20.0f, 10.0f)
                    lineTo(20.0f, 8.0f)
                    close()
                    moveTo(14.0f, 16.0f)
                    horizontalLineToRelative(-4.0f)
                    verticalLineToRelative(-2.0f)
                    horizontalLineToRelative(4.0f)
                    verticalLineToRelative(2.0f)
                    close()
                    moveTo(14.0f, 12.0f)
                    horizontalLineToRelative(-4.0f)
                    verticalLineToRelative(-2.0f)
                    horizontalLineToRelative(4.0f)
                    verticalLineToRelative(2.0f)
                    close()
                }
            }
            return _bugReport!!
        }

    val ChevronLeft: ImageVector
        get() {
            if (_chevronLeft != null) return _chevronLeft!!
            _chevronLeft = materialIcon(name = "Filled.ChevronLeft") {
                materialPath {
                    moveTo(15.41f, 7.41f)
                    lineTo(14.0f, 6.0f)
                    lineToRelative(-6.0f, 6.0f)
                    lineToRelative(6.0f, 6.0f)
                    lineToRelative(1.41f, -1.41f)
                    lineTo(10.83f, 12.0f)
                    close()
                }
            }
            return _chevronLeft!!
        }

    val ChevronRight: ImageVector
        get() {
            if (_chevronRight != null) return _chevronRight!!
            _chevronRight = materialIcon(name = "Filled.ChevronRight") {
                materialPath {
                    moveTo(10.0f, 6.0f)
                    lineTo(8.59f, 7.41f)
                    lineTo(13.17f, 12.0f)
                    lineToRelative(-4.58f, 4.59f)
                    lineTo(10.0f, 18.0f)
                    lineToRelative(6.0f, -6.0f)
                    close()
                }
            }
            return _chevronRight!!
        }

    val RadioButtonChecked: ImageVector
        get() {
            if (_radioButtonChecked != null) return _radioButtonChecked!!
            _radioButtonChecked = materialIcon(name = "Filled.RadioButtonChecked") {
                materialPath {
                    moveTo(12.0f, 7.0f)
                    curveToRelative(-2.76f, 0.0f, -5.0f, 2.24f, -5.0f, 5.0f)
                    reflectiveCurveToRelative(2.24f, 5.0f, 5.0f, 5.0f)
                    reflectiveCurveToRelative(5.0f, -2.24f, 5.0f, -5.0f)
                    reflectiveCurveToRelative(-2.24f, -5.0f, -5.0f, -5.0f)
                    close()
                    moveTo(12.0f, 2.0f)
                    curveTo(6.48f, 2.0f, 2.0f, 6.48f, 2.0f, 12.0f)
                    reflectiveCurveToRelative(4.48f, 10.0f, 10.0f, 10.0f)
                    reflectiveCurveToRelative(10.0f, -4.48f, 10.0f, -10.0f)
                    reflectiveCurveTo(17.52f, 2.0f, 12.0f, 2.0f)
                    close()
                    moveTo(12.0f, 20.0f)
                    curveToRelative(-4.42f, 0.0f, -8.0f, -3.58f, -8.0f, -8.0f)
                    reflectiveCurveToRelative(3.58f, -8.0f, 8.0f, -8.0f)
                    reflectiveCurveToRelative(8.0f, 3.58f, 8.0f, 8.0f)
                    reflectiveCurveToRelative(-3.58f, 8.0f, -8.0f, 8.0f)
                    close()
                }
            }
            return _radioButtonChecked!!
        }

    val RadioButtonUnchecked: ImageVector
        get() {
            if (_radioButtonUnchecked != null) return _radioButtonUnchecked!!
            _radioButtonUnchecked = materialIcon(name = "Filled.RadioButtonUnchecked") {
                materialPath {
                    moveTo(12.0f, 2.0f)
                    curveTo(6.48f, 2.0f, 2.0f, 6.48f, 2.0f, 12.0f)
                    reflectiveCurveToRelative(4.48f, 10.0f, 10.0f, 10.0f)
                    reflectiveCurveToRelative(10.0f, -4.48f, 10.0f, -10.0f)
                    reflectiveCurveTo(17.52f, 2.0f, 12.0f, 2.0f)
                    close()
                    moveTo(12.0f, 20.0f)
                    curveToRelative(-4.42f, 0.0f, -8.0f, -3.58f, -8.0f, -8.0f)
                    reflectiveCurveToRelative(3.58f, -8.0f, 8.0f, -8.0f)
                    reflectiveCurveToRelative(8.0f, 3.58f, 8.0f, 8.0f)
                    reflectiveCurveToRelative(-3.58f, 8.0f, -8.0f, 8.0f)
                    close()
                }
            }
            return _radioButtonUnchecked!!
        }

    val Restore: ImageVector
        get() {
            if (_restore != null) return _restore!!
            _restore = materialIcon(name = "Filled.Restore") {
                materialPath {
                    moveTo(13.0f, 3.0f)
                    curveToRelative(-4.97f, 0.0f, -9.0f, 4.03f, -9.0f, 9.0f)
                    lineTo(1.0f, 12.0f)
                    lineToRelative(3.89f, 3.89f)
                    lineToRelative(0.07f, 0.14f)
                    lineTo(9.0f, 12.0f)
                    lineTo(6.0f, 12.0f)
                    curveToRelative(0.0f, -3.87f, 3.13f, -7.0f, 7.0f, -7.0f)
                    reflectiveCurveToRelative(7.0f, 3.13f, 7.0f, 7.0f)
                    reflectiveCurveToRelative(-3.13f, 7.0f, -7.0f, 7.0f)
                    curveToRelative(-1.93f, 0.0f, -3.68f, -0.79f, -4.94f, -2.06f)
                    lineToRelative(-1.42f, 1.42f)
                    curveTo(8.27f, 19.99f, 10.51f, 21.0f, 13.0f, 21.0f)
                    curveToRelative(4.97f, 0.0f, 9.0f, -4.03f, 9.0f, -9.0f)
                    reflectiveCurveToRelative(-4.03f, -9.0f, -9.0f, -9.0f)
                    close()
                    moveTo(12.0f, 8.0f)
                    verticalLineToRelative(5.0f)
                    lineToRelative(4.28f, 2.54f)
                    lineToRelative(0.72f, -1.21f)
                    lineToRelative(-3.5f, -2.08f)
                    lineTo(13.5f, 8.0f)
                    lineTo(12.0f, 8.0f)
                    close()
                }
            }
            return _restore!!
        }

    // Material's History and Restore are the same glyph.
    val History: ImageVector
        get() = Restore

    val StarRate: ImageVector
        get() {
            if (_starRate != null) return _starRate!!
            _starRate = materialIcon(name = "Filled.StarRate") {
                materialPath {
                    moveTo(14.43f, 10.0f)
                    lineToRelative(-2.43f, -8.0f)
                    lineToRelative(-2.43f, 8.0f)
                    lineToRelative(-7.57f, 0.0f)
                    lineToRelative(6.18f, 4.41f)
                    lineToRelative(-2.35f, 7.59f)
                    lineToRelative(6.17f, -4.69f)
                    lineToRelative(6.18f, 4.69f)
                    lineToRelative(-2.35f, -7.59f)
                    lineToRelative(6.17f, -4.41f)
                    close()
                }
            }
            return _starRate!!
        }

    val Update: ImageVector
        get() {
            if (_update != null) return _update!!
            _update = materialIcon(name = "Filled.Update") {
                materialPath {
                    moveTo(21.0f, 10.12f)
                    horizontalLineToRelative(-6.78f)
                    lineToRelative(2.74f, -2.82f)
                    curveToRelative(-2.73f, -2.7f, -7.15f, -2.8f, -9.88f, -0.1f)
                    curveToRelative(-2.73f, 2.71f, -2.73f, 7.08f, 0.0f, 9.79f)
                    reflectiveCurveToRelative(7.15f, 2.71f, 9.88f, 0.0f)
                    curveTo(18.32f, 15.65f, 19.0f, 14.08f, 19.0f, 12.1f)
                    horizontalLineToRelative(2.0f)
                    curveToRelative(0.0f, 1.98f, -0.88f, 4.55f, -2.64f, 6.29f)
                    curveToRelative(-3.51f, 3.48f, -9.21f, 3.48f, -12.72f, 0.0f)
                    curveToRelative(-3.5f, -3.47f, -3.53f, -9.11f, -0.02f, -12.58f)
                    reflectiveCurveToRelative(9.14f, -3.47f, 12.65f, 0.0f)
                    lineTo(21.0f, 3.0f)
                    verticalLineTo(10.12f)
                    close()
                    moveTo(12.5f, 8.0f)
                    verticalLineToRelative(4.25f)
                    lineToRelative(3.5f, 2.08f)
                    lineToRelative(-0.72f, 1.21f)
                    lineTo(11.0f, 13.0f)
                    verticalLineTo(8.0f)
                    horizontalLineTo(12.5f)
                    close()
                }
            }
            return _update!!
        }

    val Upgrade: ImageVector
        get() {
            if (_upgrade != null) return _upgrade!!
            _upgrade = materialIcon(name = "Filled.Upgrade") {
                materialPath {
                    moveTo(16.0f, 18.0f)
                    verticalLineToRelative(2.0f)
                    horizontalLineTo(8.0f)
                    verticalLineToRelative(-2.0f)
                    horizontalLineTo(16.0f)
                    close()
                    moveTo(11.0f, 7.99f)
                    verticalLineTo(16.0f)
                    horizontalLineToRelative(2.0f)
                    verticalLineTo(7.99f)
                    horizontalLineToRelative(3.0f)
                    lineTo(12.0f, 4.0f)
                    lineTo(8.0f, 7.99f)
                    horizontalLineTo(11.0f)
                    close()
                }
            }
            return _upgrade!!
        }

    val Visibility: ImageVector
        get() {
            if (_visibility != null) return _visibility!!
            _visibility = materialIcon(name = "Filled.Visibility") {
                materialPath {
                    moveTo(12.0f, 4.5f)
                    curveTo(7.0f, 4.5f, 2.73f, 7.61f, 1.0f, 12.0f)
                    curveToRelative(1.73f, 4.39f, 6.0f, 7.5f, 11.0f, 7.5f)
                    reflectiveCurveToRelative(9.27f, -3.11f, 11.0f, -7.5f)
                    curveToRelative(-1.73f, -4.39f, -6.0f, -7.5f, -11.0f, -7.5f)
                    close()
                    moveTo(12.0f, 17.0f)
                    curveToRelative(-2.76f, 0.0f, -5.0f, -2.24f, -5.0f, -5.0f)
                    reflectiveCurveToRelative(2.24f, -5.0f, 5.0f, -5.0f)
                    reflectiveCurveToRelative(5.0f, 2.24f, 5.0f, 5.0f)
                    reflectiveCurveToRelative(-2.24f, 5.0f, -5.0f, 5.0f)
                    close()
                    moveTo(12.0f, 9.0f)
                    curveToRelative(-1.66f, 0.0f, -3.0f, 1.34f, -3.0f, 3.0f)
                    reflectiveCurveToRelative(1.34f, 3.0f, 3.0f, 3.0f)
                    reflectiveCurveToRelative(3.0f, -1.34f, 3.0f, -3.0f)
                    reflectiveCurveToRelative(-1.34f, -3.0f, -3.0f, -3.0f)
                    close()
                }
            }
            return _visibility!!
        }

    val WorkspacePremium: ImageVector
        get() {
            if (_workspacePremium != null) return _workspacePremium!!
            _workspacePremium = materialIcon(name = "Filled.WorkspacePremium") {
                materialPath {
                    moveTo(9.68f, 13.69f)
                    lineTo(12.0f, 11.93f)
                    lineToRelative(2.31f, 1.76f)
                    lineToRelative(-0.88f, -2.85f)
                    lineTo(15.75f, 9.0f)
                    horizontalLineToRelative(-2.84f)
                    lineTo(12.0f, 6.19f)
                    lineTo(11.09f, 9.0f)
                    horizontalLineTo(8.25f)
                    lineToRelative(2.31f, 1.84f)
                    lineTo(9.68f, 13.69f)
                    close()
                    moveTo(20.0f, 10.0f)
                    curveToRelative(0.0f, -4.42f, -3.58f, -8.0f, -8.0f, -8.0f)
                    reflectiveCurveToRelative(-8.0f, 3.58f, -8.0f, 8.0f)
                    curveToRelative(0.0f, 2.03f, 0.76f, 3.87f, 2.0f, 5.28f)
                    verticalLineTo(23.0f)
                    lineToRelative(6.0f, -2.0f)
                    lineToRelative(6.0f, 2.0f)
                    verticalLineToRelative(-7.72f)
                    curveTo(19.24f, 13.87f, 20.0f, 12.03f, 20.0f, 10.0f)
                    close()
                    moveTo(12.0f, 4.0f)
                    curveToRelative(3.31f, 0.0f, 6.0f, 2.69f, 6.0f, 6.0f)
                    reflectiveCurveToRelative(-2.69f, 6.0f, -6.0f, 6.0f)
                    reflectiveCurveToRelative(-6.0f, -2.69f, -6.0f, -6.0f)
                    reflectiveCurveTo(8.69f, 4.0f, 12.0f, 4.0f)
                    close()
                }
            }
            return _workspacePremium!!
        }

    private var _menuOpen: ImageVector? = null
    private var _adsClick: ImageVector? = null
    private var _bugReport: ImageVector? = null
    private var _chevronLeft: ImageVector? = null
    private var _chevronRight: ImageVector? = null
    private var _radioButtonChecked: ImageVector? = null
    private var _radioButtonUnchecked: ImageVector? = null
    private var _restore: ImageVector? = null
    private var _starRate: ImageVector? = null
    private var _update: ImageVector? = null
    private var _upgrade: ImageVector? = null
    private var _workspacePremium: ImageVector? = null
    private var _visibility: ImageVector? = null

    /** Material "trending_up": a popular search of all users. */
    val TrendingUp: ImageVector
        get() {
            if (_trendingUp != null) return _trendingUp!!
            _trendingUp = materialIcon(name = "Filled.TrendingUp") {
                materialPath {
                    moveTo(16.0f, 6.0f)
                    lineTo(18.29f, 8.29f)
                    lineTo(13.41f, 13.17f)
                    lineTo(9.41f, 9.17f)
                    lineTo(2.0f, 16.59f)
                    lineTo(3.41f, 18.0f)
                    lineTo(9.41f, 12.0f)
                    lineTo(13.41f, 16.0f)
                    lineTo(19.71f, 9.71f)
                    lineTo(22.0f, 12.0f)
                    verticalLineTo(6.0f)
                    close()
                }
            }
            return _trendingUp!!
        }

    private var _trendingUp: ImageVector? = null

    /**
     * Material "north_west": puts a suggestion in the search field without running it. Mirrored
     * in right-to-left layouts, where the field's start is on the right.
     */
    val NorthWest: ImageVector
        get() {
            if (_northWest != null) return _northWest!!
            _northWest = materialIcon(name = "Filled.NorthWest", autoMirror = true) {
                materialPath {
                    moveTo(5.0f, 15.0f)
                    horizontalLineTo(7.0f)
                    verticalLineTo(8.41f)
                    lineTo(18.59f, 20.0f)
                    lineTo(20.0f, 18.59f)
                    lineTo(8.41f, 7.0f)
                    horizontalLineTo(15.0f)
                    verticalLineTo(5.0f)
                    horizontalLineTo(5.0f)
                    verticalLineTo(15.0f)
                    close()
                }
            }
            return _northWest!!
        }

    private var _northWest: ImageVector? = null
}
